import { CirclePicker, CirclePickerProps, ColorChangeHandler } from 'react-color';
import * as React from 'react';
import Modal from '@/components/atoms/Modal';
import { ColorButton } from './ColorPicker.style';

export const ColorPicker: React.FunctionComponent<ColorPickerProps> = ({ value = '#FFFFFF', onChange, ...props }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const handleChange: ColorChangeHandler = (color) => {
        onChange?.(color.hex);
    };

    const handleClose = () => setIsOpen(false);
    const handleOpen = () => setIsOpen(true);

    return (
        <>
            <ColorButton
                data-testid="colorPicker-button"
                type="button"
                onClick={handleOpen}
                style={value ? { background: value } : {}}
            />
            <Modal isOpen={isOpen} onHide={handleClose}>
                <CirclePicker color={value ?? undefined} onChange={handleChange} {...props} />
            </Modal>
        </>
    );
};

export interface ColorPickerProps extends Omit<CirclePickerProps, 'color' | 'onChange'> {
    value?: string;
    onChange?: (color: string) => void;
}
